/**
 * How it works.
 * At the current time there are 3 events, Bind, Bound, and Ready
 * bind:  this calls the component and has a node to attach itself to
 * bound: this is a call made by the component once it binds itself
 * ready: this is a call the component makes when it is loaded.
 */

export const getActionName = {
    ready: (componentName: string) => `exportedComponent.ready.${componentName}`,
    bind: (componentName: string) => `exportedComponent.bind.${componentName}`,
    bound: (componentName: string) => `exportedComponent.bound.${componentName}`
};
